import { Button } from "../../../components/ui/button";
import { Badge } from "../../../components/ui/badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIdCard,
  faPhone,
  faEnvelope,
  faCalendarPlus,
  faCalendarCheck,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import Modal from "../../../components/ui/modal";
import {
  statusStyles,
  statusDotStyles,
  positionStyles,
} from "../../../utils/styles";

const ViewDetailsModal = ({ customer, isOpen, onClose }) => {
  const formatDate = (date) => {
    if (!date) return "-";
    const d = new Date(date);
    return d.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Customer details"
      footer={
        <div className="flex justify-end">
          <Button
            variant="outline"
            onClick={onClose}
            className="w-full sm:w-auto px-6 border-2 border-orange-700 text-red-600 hover:text-white hover:bg-orange-600 hover:border-none"
          >
            Close
          </Button>
        </div>
      }
    >
      {customer && (
        <div className="flex flex-col gap-5">
          <div className="flex items-center gap-4 p-4 bg-gradient-to-r from-blue-50 to-white rounded-xl border border-blue-100">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-blue-800 to-blue-600 flex items-center justify-center shadow-md">
              <FontAwesomeIcon
                icon={faUserCircle}
                className="text-white h-8 w-8"
              />
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900">
                {customer.full_name}
              </h3>
              <p className="text-sm text-gray-600">{customer.customer_no}</p>
              <div className="flex items-center gap-2 mt-1">
                <Badge
                  variant="outline"
                  className={positionStyles[customer.position]}
                >
                  {customer.position}
                </Badge>
                <Badge
                  variant="outline"
                  className={statusStyles[customer.status]}
                >
                  <span
                    className={`inline-block w-1.5 h-1.5 rounded-full ${statusDotStyles[customer.status]} mr-1.5`}
                  />
                  {customer.status}
                </Badge>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
              <FontAwesomeIcon
                icon={faIdCard}
                className="text-blue-800 h-4 w-4 mt-0.5"
              />
              <div>
                <p className="text-xs text-gray-600 font-medium uppercase tracking-wider">
                  Customer No
                </p>
                <p className="text-sm font-semibold text-gray-900">
                  {customer.customer_no}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100">
              <FontAwesomeIcon
                icon={faPhone}
                className="text-blue-800 h-4 w-4 mt-0.5"
              />
              <div>
                <p className="text-xs text-gray-600 font-medium uppercase tracking-wider">
                  Phone Number
                </p>
                <p className="text-sm font-semibold text-gray-900">
                  {customer.phone_number}
                </p>
              </div>
            </div>

            <div className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg border border-gray-100 col-span-1 sm:col-span-2">
              <FontAwesomeIcon
                icon={faEnvelope}
                className="text-blue-800 h-4 w-4 mt-0.5"
              />
              <div className="flex-1 min-w-0">
                <p className="text-xs text-gray-600 font-medium uppercase tracking-wider">
                  Email Address
                </p>
                <p className="text-sm font-semibold text-gray-900 truncate">
                  {customer.email || "-"}
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-3 border-t border-gray-200">
            <div className="flex items-center gap-3 p-3 bg-blue-50/50 rounded-lg border border-blue-100">
              <FontAwesomeIcon
                icon={faCalendarPlus}
                className="text-blue-800 h-4 w-4"
              />
              <div>
                <p className="text-xs text-gray-600 font-medium uppercase tracking-wider">
                  Created At
                </p>
                <p className="text-sm font-semibold text-gray-900">
                  {formatDate(customer.created_at)}
                </p>
              </div>
            </div>

            <div className="flex items-center gap-3 p-3 bg-purple-50/50 rounded-lg border border-purple-100">
              <FontAwesomeIcon
                icon={faCalendarCheck}
                className="text-purple-800 h-4 w-4"
              />
              <div>
                <p className="text-xs text-gray-600 font-medium uppercase tracking-wider">
                  Updated At
                </p>
                <p className="text-sm font-semibold text-gray-900">
                  {formatDate(customer.updated_at)}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ViewDetailsModal;
